module.exports = __webpack_public_path__ + "img/cooler_des_4.254e5930.jpg";